// You can write more code here

/* START OF COMPILED CODE */

import EntityRelic from '../EntityRelic';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class RelicBronzeBoots extends EntityRelic {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 74, y ?? 47);

    // boots
    const boots = scene.add.image(0, 0, 'game-all', 'relic-boots.png');
    boots.scaleX = 0.5;
    boots.scaleY = 0.5;
    this.add(boots);

    this.boots = boots;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private boots: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.boots.displayWidth, this.boots.displayHeight);

    super.injectMatter(target);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
